import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Correct import
import rootReducer from "./reducers/RootReducer"; // Ensure this is correct path
// import { createLogger } from "redux-logger";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const logger = createLogger({
//   predicate: () => process.env.NODE_ENV === "development",
// });

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  // devTools: process.env.NODE_ENV === "development",
});

const persistor = persistStore(store);

export { store, persistor };
